export default "__VITE_ASSET__N31Qdi3H__"